import { v4 } from 'uuid';

class Uuid {
    private uuid: string;

    constructor() {
        this.uuid = v4();
    }

    /**
     * Return a random number uuid using uuid generator
     * @return random number uuid
     */
    public toString(): string {
        return this.uuid;
    }
}
export default Uuid;
